import { render, staticRenderFns } from "./LegendTag.vue?vue&type=template&id=5d9b1f70&"
import script from "./LegendTag.vue?vue&type=script&lang=js&"
export * from "./LegendTag.vue?vue&type=script&lang=js&"
import style0 from "./LegendTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports